import { useService } from '../common';
import { useCallback, useMemo } from 'react';
import { Email } from './types';
import type { ServiceResponse } from '../common/types';

const API = {
    MESSAGE_EMAIL: '/message/deliver',
};

export const useMessageService = () => {
    const service = useService();

    const sendEmail = useCallback((requestBody: Email): ServiceResponse => {
        return service.sendPostWithAuthorization(API.MESSAGE_EMAIL, requestBody)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);

    return useMemo(() => ({
        sendEmail,
    }), [sendEmail]);
};